import { Toolbar } from "ngx-editor";
import { nodes as basicNodes, marks } from 'ngx-editor';
import { Schema, NodeSpec } from 'prosemirror-model';

export const DEFAULT_EDITOR_TOOLBAR: Toolbar = [
  ['bold', 'italic'],
  ['underline', 'strike'],
  ['blockquote'],
  ['ordered_list', 'bullet_list'],
  [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
  ['link'],
  ['text_color', 'background_color'],
  ['align_left', 'align_center', 'align_right', 'align_justify'],
  ['undo', 'redo'],
]

const codeMirror: NodeSpec = {
  content: 'text*',
  marks: '',
  group: 'block',
  code: true,
  defining: true,
  isolating: true,
  parseDOM: [
    {
      tag: 'pre',
      preserveWhitespace: 'full',
    },
  ],
  toDOM() {
    return ['pre', ['code', 0]];
  },
};

const nodes = Object.assign({}, basicNodes, {
  code_mirror: codeMirror,
});

const schema = new Schema({
  nodes,
  marks,
});

export { schema };

export const DEFAULT_COLOR_PRESETS = [
  '#b60205',
  '#d93f0b',
  '#fbca04',
  '#0e8a16',
  '#006b75',
  '#1d76db',
  '#0052cc',
  '#5319e7',
  '#e99695',
  '#f9d0c4',
  '#fef2c0',
  '#c2e0c6',
  '#bfdadc',
  '#c5def5',
  '#bfd4f2',
  '#d4c5f9',
  // Additional 20 colors
  '#ff5733',
  '#33ff57',
  'pink',
  '#242424',
  '#fff',
  '#33a1ff',
  '#ff8c00',
  '#000000',
];
